import { Link, useLocation } from 'react-router-dom';
import { useSideNav } from '../context/SideNavContext';
import { useAuth } from '../context/AuthContext';
import Icon from '../components/Icon';
import { ICONS } from '../lib/icons';

// Route → breadcrumb label. The base segment is matched so detail routes
// (e.g. /providers/aws) still resolve to their section.
const LABELS = {
  '/home': 'Console Home',
  '/services': 'All services',
  '/providers': 'Providers',
  '/resources': 'Resources',
  '/contracts': 'Contract management',
  '/prices': 'Price management',
  '/billing': 'Billing',
  '/costs': 'Cost & Billing',
  '/activity': 'Activity',
  '/superadmin': 'Superadmin',
};

// The secondary bar: nav toggle + breadcrumb + info, mirroring the thin bar
// beneath the AWS console's black app bar.
export default function Subbar({ onToggleNav }) {
  const { pathname } = useLocation();
  const { nav } = useSideNav();
  const { allows } = useAuth();
  const base = '/' + (pathname.split('/')[1] || '');
  const isHome = pathname === '/home';
  // Inside a service, the service menu title (or short crumb) drives it.
  const label =
    nav?.crumb || nav?.title || LABELS[pathname] || LABELS[base] || 'Console';

  return (
    <div className="subbar">
      <div className="subbar__left">
        <button
          className="subbar__menu"
          onClick={onToggleNav}
          aria-label="Toggle navigation"
        >
          <Icon name={ICONS.menu} />
        </button>
        <nav className="subbar__crumbs" aria-label="Breadcrumb">
          {/* Console home is grantable, so the root crumb is only a link when a
              policy allows that area; otherwise it stays plain text. */}
          {allows('home') ? (
            <Link className="subbar__crumb-link" to="/home">
              Console Home
            </Link>
          ) : (
            <span className="subbar__crumb-current">Console Home</span>
          )}
          {!isHome && (
            <>
              <Icon name={ICONS.chevronRight} className="subbar__crumb-sep" />
              <span className="subbar__crumb-current">{label}</span>
            </>
          )}
        </nav>
      </div>
      <button className="subbar__info" title="Info" aria-label="Info">
        <Icon name={ICONS.info} />
      </button>
    </div>
  );
}
